import { TimeInterval } from "rxjs";
import { Show } from "./show";
import { Time } from "@angular/common";
import { PartnerGroup } from "./partner-group";

export class PartnerPro {
    PROShowId: number = 0;
    id: number = 0;
    year: number = 0;
    quarter: string = '';
    distributionYear: number | null = null;
    distributionQuarter: string | null = null;
    statementRecipientId: number | null = null;
    statementRecipientName: string | null = null;
    partyId: number | null = null;
    partyName: string | null = null;
    legalEarnerPartyId: number | null = null;
    legalEarnerPartyName: string | null = null;
    performanceSource: string | null = null;
    musicUserGenre: string | null = null;
    musicUser: string | null = null;
    networkService: string | null = null;
    performanceStartDate: Date | null = null;
    performanceEndDate: Date | null = null;
    surveyType: string | null = null;
    dayPartCode: number | null = null;
    show: Show | null = null;; //this really shouldn't be null - but leaving it as such
    unrecognizedShow: string | null = null;
    episodeName: string | null = null;
    workId: number | null = null;
    workTitle: string | null = null;
    allocationPercentage: number | null = null;
    classificationCode: number | null = null;
    numberOfPlays: number | null = null;
    performanceType: string | null = null;
    duration: Time | null = null; //not positive if Time is the best data type for this
    performingArtist: string | null = null;
    composerName: string | null = null;
    eeShare: number | null = null;
    credits: number | null = null;
    royalty: number | null = null;
    adj_usd: number | null = null;
    premiumCredits: number | null = null;
    premiumRoyalty: number | null = null;
    adjustmentIndicator: string | null = null;
    adjustmentReasonCode: number | null = null;
    originalDistributionDate: Date | null = null;
    roleType: string | null = null;
    typeOfRight: string | null = null;
    territory: string | null = null;
    licensor: string | null = null;
    programCode: number | null = null;
    performanceQuarter: string | null = null;

    countryName: string | null = null;
    fileType: string | null = null;
    licensorCode: string | null = null;
    revenueClassCode: number | null = null;
    revenueClassDescription: string | null = null;
    adjustmentDistributionDate: Date | null = null;

    currentActivityAmt: number | null = null;
    hitSongBonus: number | null = null;
    standardsBonus: number | null = null;
    foreignSocietyAdjustment: string | null = null;
    perfDate: Date | null = null;
    wOrP: string | null = null;

    showName: string | null = null;
    paymentType: string | null = null;
    chart: string | null = null;
    position: number | null = null;
    payNumber: number | null = null;
    synd: string | null = null;
    strip: string | null = null;
    performance: number | null = null;
    occur: number | null = null;
    societyAbbrv: string | null = null;
    societyCountry: string | null = null;
    showName: string | null = null;

    addedById: number = 0; // should never be null
    updatedById: number = 0; //should never be null

    createdAt: Date = new Date(); // should never be null
    updatedAt: Date = new Date(); // should never be null

    isApproved: boolean = false;
    pendingApproval: boolean = false; //NEED TO UPDATE DATA MODEL ON BACKEND

    mapToShow: Show | null = null; //for frontend use only

    selectedGroups: PartnerGroup[] = []; // for front end use only

    static mapProperties(item: any): PartnerPro {
        let partnerPro = new PartnerPro();
    
        partnerPro.PROShowId = item.PROShowId;
        partnerPro.id = item.id;
        partnerPro.year = item.year;
        partnerPro.quarter = item.quarter;
        partnerPro.distributionYear = item.distribution_year;
        partnerPro.distributionQuarter = item.distribution_quarter;
        partnerPro.statementRecipientId = item.statement_recipient_id;
        partnerPro.statementRecipientName = item.statement_recipient_name;
        partnerPro.partyId = item.party_id;
        partnerPro.partyName = item.party_name;
        partnerPro.legalEarnerPartyId = item.legal_earner_party_id;
        partnerPro.legalEarnerPartyName = item.legal_earner_party_name;
        partnerPro.performanceSource = item.performance_source;
        partnerPro.musicUserGenre = item.music_user_genre;
        partnerPro.musicUser = item.music_user;
        partnerPro.networkService = item.network_service;
        partnerPro.performanceStartDate = item.performance_start_date ? new Date(item.performance_start_date) : null;
        partnerPro.performanceEndDate = item.performance_end_date ? new Date(item.performance_end_date) : null;
        partnerPro.surveyType = item.survey_type;
        partnerPro.dayPartCode = item.day_part_code;
        partnerPro.show = item.show ? Show.mapProperties(item.show) : null;
        partnerPro.mapToShow = item.show ? Show.mapProperties(item.show) : null; //front end use only
        partnerPro.unrecognizedShow = item.unrecognized_show,
        partnerPro.episodeName = item.episode_name;
        partnerPro.workId = item.work_id;
        partnerPro.workTitle = item.work_title;
        partnerPro.allocationPercentage = item.allocation_percentage;
        partnerPro.classificationCode = item.classification_code;
        partnerPro.numberOfPlays = item.number_of_plays;
        partnerPro.performanceType = item.performance_type;
        partnerPro.duration = item.duration;
        partnerPro.performingArtist = item.performing_artist;
        partnerPro.composerName = item.composer_name;
        partnerPro.eeShare = item.ee_share;
        partnerPro.credits = item.credits;
        partnerPro.royalty = item.royalty;
        partnerPro.adj_usd = item.adj_usd;
        partnerPro.premiumCredits = item.premium_credits;
        partnerPro.premiumRoyalty = item.premium_royalty;
        partnerPro.adjustmentIndicator = item.adjustment_indicator;
        partnerPro.adjustmentReasonCode = item.adjustment_reason_code;
        partnerPro.originalDistributionDate = item.original_distribution_date ? new Date(item.original_distribution_date) : null;
        partnerPro.roleType = item.role_type;
        partnerPro.typeOfRight = item.type_of_right;
        partnerPro.territory = item.terriotry;
        partnerPro.licensor = item.licensor;
        partnerPro.programCode = item.program_code;
        partnerPro.performanceQuarter = item.performance_quarter;
        partnerPro.countryName = item.country_name;
        partnerPro.fileType = item.file_type;
        partnerPro.licensorCode = item.licensor_code;
        partnerPro.revenueClassCode = item.revenue_class_code;
        partnerPro.revenueClassDescription = item.revenue_class_description;
        partnerPro.adjustmentDistributionDate = item.adjustment_distribution_date ? new Date(item.adjustent_distribution_date) : null;
        partnerPro.currentActivityAmt = item.current_activity_amt;
        partnerPro.hitSongBonus = item.hit_song_bonus;
        partnerPro.standardsBonus = item.standards_bonus;
        partnerPro.foreignSocietyAdjustment = item.foreign_society_adjustment;
        partnerPro.perfDate = item.perf_date ? new Date(item.perf_date) : null;
        partnerPro.wOrP = item.w_or_d;
        partnerPro.showName = item.album_title;
        partnerPro.paymentType = item.payment_type;
        partnerPro.chart = item.chart;
        partnerPro.position = item.position;
        partnerPro.payNumber = item.pay_number;
        partnerPro.synd = item.synd;
        partnerPro.strip = item.strip;
        partnerPro.performance = item.performance;
        partnerPro.occur = item.occur;
        partnerPro.societyAbbrv = item.society_abbrv;
        partnerPro.societyCountry = item.society_country;
        partnerPro.addedById = item.added_by_id;
        partnerPro.updatedById = item.updated_by_id;
        partnerPro.createdAt = item.created_at ? new Date(item.created_at) : new Date();
        partnerPro.updatedAt = item.updated_at ? new Date(item.updated_at) : new Date();
        partnerPro.isApproved = item.is_approved;
        partnerPro.showName = item.show_name;

        partnerPro.pendingApproval = false; //NEED TO UPDATE BACKEND DATA MODEL
        
        return partnerPro;
      }
}
